export function LiveBadge() {
    return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase bg-rose-50 text-rose-700 border border-rose-200">
            <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inset-0 rounded-full bg-rose-400 animate-ping opacity-40" />
                <span className="relative rounded-full h-2.5 w-2.5 bg-rose-500" />
            </span>
            Live
        </span>
    );
}
